<template>
    <label class="toggle-switch">
        <input type="checkbox" v-model="isChecked" @change="handleToggle" class="toggle-switch__input" />
        <div class="toggle-switch__labels" ref="containerRef">
            <span ref="leftLabelRef" class="toggle-switch__label" :class="{ active: !isChecked }">
                {{ from.title }}
            </span>
            <span ref="rightLabelRef" class="toggle-switch__label" :class="{ active: isChecked }">
                {{ to.title }}
            </span>
            <div class="toggle-switch__slider" :style="{
                width: sliderWidth + 'px',
                transform: `translateX(${sliderOffset}px) translateY(-50%)`
            }" />
        </div>
    </label>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';

const props = defineProps({
    from: Object,
    to: Object,
});
const emit = defineEmits(['update:selectedId']);


const isChecked = ref(false);
const leftLabelRef = ref(null);
const rightLabelRef = ref(null);
const containerRef = ref(null);
const sliderWidth = ref(0);
const sliderOffset = ref(0);

watch(
    () => [props.from.active, props.to.active],
    () => {
        if (props.to.active) {
            isChecked.value = true;
        } else if (props.from.active) {
            isChecked.value = false;
        }
        nextTick(() => updateSlider());
    },
    { immediate: true }
);

let resizeObserver;

function updateSlider() {
    const target = isChecked.value ? rightLabelRef.value : leftLabelRef.value;
    if (!target) return;
    sliderWidth.value = target.offsetWidth;
    sliderOffset.value = target.offsetLeft;
}

function handleToggle() {
    const selectedId = isChecked.value ? props.to.id : props.from.id;
    emit('update:selectedId', selectedId);
}

onMounted(() => {
    nextTick(() => {
        updateSlider();
        resizeObserver = new ResizeObserver(updateSlider);
        if (leftLabelRef.value) resizeObserver.observe(leftLabelRef.value);
        if (rightLabelRef.value) resizeObserver.observe(rightLabelRef.value);
    });
});

onBeforeUnmount(() => {
    if (resizeObserver) resizeObserver.disconnect();
});


</script>


<style scoped>
.toggle-switch {
    display: inline-block;
    cursor: pointer;
    user-select: none;
}

.toggle-switch__input {
    display: none;
}

.toggle-switch__labels {
    display: flex;
    position: relative;
    border-radius: 999px;
    overflow: hidden;
    font-family: 'Poppins', sans-serif;
    font-size: 1.4rem;
    font-weight: 500;
    background-color: #EFEFEF;
    transition: all 0.3s ease;
    align-items: center;
}

.toggle-switch__label {
    padding: 1.5em 2em;
    text-align: center;
    z-index: 1;
    transition: color 0.3s ease;
    white-space: nowrap;
}

/* .toggle-switch__label.active {
    color: #FFFFFF;
} */

.toggle-switch__slider {
    position: absolute;
    top: 50%;
    left: 0;
    height: 100%;
    background-color: #FFFFFF;
    border: 10px solid #EFEFEF;
    border-radius: 999px;
    transition: transform 0.3s ease, width 0.3s ease;
    z-index: 0;
    transform: translateY(-50%) translateX(0);
}
</style>
